(function (ws) {
    'use strict';
    /**
     * @typedef {Object} Event - event object
     * @typedef {Object} Array - array object
     */
    ws.views.quoteEndUser = ws.views.googleAnalytics.extend({

        /**
         * Initialize override.
         */
        initialize: function() {
            this.$endUserName = this.$('#endUserName');
            this.$endUserNameInput = this.$('input[name="endUserName"]');
            this.$endUserNameValue = this.$('#endUserNameValue');
            this.$endUserCompanyName = this.$('#endUserCompanyName');
            this.$endUserAccountError = this.$('.qut-invalid-account-user');
            this.$trilliumError = this.$('.qut-trillium-invalid-account-user');
            this.$endUserGenericError = this.$('.qut-generic-error-user');
            this.endUserDetailTpl = this.$('#qut-search-enduser-details');
            this.endUserSelected = $('#qut-search-enduser-selected');
            this.$endUserAccountRequiredLabel = this.$('.qut-required-account-user');
            this.$endUserSpanContent = this.$('.qut-endUser-span');
            this.$endUserSpanSelected = $('.qut-endUser-selected');
            this.$endUserAccountSearch = this.$('#endUserUid');
            this.$endUserAccountSearchBtn = this.$('.qut-uid-search-btn');
            this.$resetPricingEnabled = this.$('#resetPricingEnabled');
            this.quoteId = this.getQuoteId();
            this.eventAgg.on('callingSearchEndUserAPI', this.callingSearchEndUserAPI, this);

            this.endUserAddressBookOptionSelected = '';
            if ($('#addressBookChanges').val() === 'true') {
                $('#endUserUid').select2({
                    width: '100%'
                });

                setTimeout(() => {
                    this.endUserAddressBookOptionSelected = $('#endUserUid').val();
                }, 4000);
            }

        },

        events: {
            'click .qut-uid-search-btn': 'searchEndUser',
            'keyup .qut-uid-search-txt': 'enableRetrieveUserBtn',
            'change .address-select-endUserUid': 'onChangeOfEnduserAddressBookAddress'
        },

        /**s
         * Trigger Addressbook change if not triggered purpousfully
         */
        onChangeOfEnduserAddressBookAddress: function (e, eventType) {
            if (eventType !== 'triggered') {
                this.searchEndUser();
            }
        },

        /**s
         * Getting the quoteId from the url
         */
        getQuoteId: function() {
            let url = window.location.pathname.split('/');
            return url[url.length - 1];
        },

        /**
         * check value of search input and disable/enable button accordingly
         */
        enableRetrieveUserBtn: function(e) {
            var disabled = $.trim(this.$endUserAccountSearch.val()).length === 0;

            this.$endUserAccountSearchBtn.toggleClass('disabled', disabled);
            this.$endUserAccountSearchBtn.prop('disabled', disabled);

            //13 enter key code
            if (!disabled && e.which === 13) {
                this.searchEndUser();
            }
        },

        /**
         * applies end user using account number search
         */
        searchEndUser: function() {
            var endUserAccountValue = this.$endUserAccountSearch.val();
            if ($('.quoteID').val() && this.$resetPricingEnabled.val() === 'true') {
                this.eventAgg.trigger('resetQuotePricingEndUser', endUserAccountValue);
            } else {
                this.callingSearchEndUserAPI(endUserAccountValue, 'NO_CHANGE');
            }
        },

        addAddressToDropdown: function (data) {
            let isExist = false;
            let optionHtml = '';
            $('#endUserUid option').each(function() {
                if (this.value == data.uid) {
                    isExist = true;
                }
            });

            if (isExist) {
                $('#endUserUid').val(data.uid).trigger('change', 'triggered');
            } else {
                optionHtml = `<option value='${data.uid}'>${data.uid ? data.uid + ' ' : ''}${data.endUserAddress[0].companyName ? data.endUserAddress[0].companyName.replace('&#40;', '(').replace('&#41;', ')') + ', ' : ''}${data.endUserAddress[0].line1 ? data.endUserAddress[0].line1 + ', ' : ''}${data.endUserAddress[0].line2 ? data.endUserAddress[0].line2 + ', ' : ''}${data.endUserAddress[0].line3 ? data.endUserAddress[0].line3 + ', ' : ''}${data.endUserAddress[0].line4 ? data.endUserAddress[0].line4 + ', ' : ''}${data.endUserAddress[0].locality ? data.endUserAddress[0].locality + ', ' : ''}${data.endUserAddress[0].town ? data.endUserAddress[0].town + ', ' : ''}${data.endUserAddress[0].region ? data.endUserAddress[0].region.name + ', ' : ''}${data.endUserAddress[0].postalCode ? data.endUserAddress[0].postalCode + ', ' : ''}${data.endUserAddress[0].country ? data.endUserAddress[0].country.name : ''}</option>`;
                $('#endUserUid').html(optionHtml);
                $('#endUserUid').val(data.uid).trigger('change', 'triggered');
            }
        },

        /**
         * Triggering the EndUser API
         */
        callingSearchEndUserAPI: function(endUserSapId, seletedOption, trilliumResp) {
            this.$endUserAccountError.hide();
            this.$trilliumError.hide();
            $('.address-select-warning-enduser, .address-select-warning-shipping').addClass('hide');
            $('.address-select-warning-enduser .text, .address-select-warning-shipping .text').empty();
            this.$endUserGenericError.hide();
            if ($.trim(endUserSapId).length > 0) {
                var updateEndUserModel = new ws.models.applyEndUserAccount({
                    quoteId: this.quoteId,
                    endUserAccount: endUserSapId,
                    sapEndUser: true,
                    trilliumResponse: trilliumResp,
                    resetPricingOption: seletedOption
                });
                this.$endUserAccountSearchBtn.addClass('spinner-after');
                this.$endUserAccountSearchBtn.addClass('disabled');
                this.$endUserAccountSearchBtn.attr('disabled', true);

                globals.disableApp();
                updateEndUserModel.save().done(function (response) {
                    globals.enableApp();
                    if (response.headerWarning) {
                        $('.address-select-warning-enduser').removeClass('hide');
                        $('.address-select-warning-enduser .text').text(response.headerWarning);
                    }

                    this.$endUserAccountRequiredLabel.hide();
                    this.$endUserAccountSearchBtn.removeClass('spinner-after');
                    if (response.error) {
                        if (response.error.startsWith('Entered account number is not validate')) {
                            this.$trilliumError.html(response.error).show();
                        } else if (response.error.startsWith('This End User is no longer valid')) {
                            this.$trilliumError.html(response.error).show();
                        } else if ($('#addressBookChanges').val() === 'true') {
                            this.$trilliumError.html(response.error).show();
                        } else {
                            this.$endUserAccountError.show();
                        }

                        if ($('#addressBookChanges').val() === 'true') {
                            $('#endUserUid').val(this.endUserAddressBookOptionSelected).trigger('change', 'triggered');
                        }

                        this.$endUserAccountSearchBtn.removeClass('disabled');
                        this.$endUserAccountSearchBtn.attr('disabled', false);
                        this.eventAgg.trigger('unNecessaryShowCall');
                    } else {
                        if (this.$endUserCompanyName.val()) {
                            this.$endUserCompanyName.val(''); //blank end user company
                        }

                        if (response.data.name && $('.qut-endUser-selected').length) {
                            $('.addAddressForm #accountName').data('value', response.data.name);
                            $('#endUserSearchForm #endUserName').data('value', response.data.name);
                        }

                        this.$endUserAccountSearch.val('');
                        this.$endUserName.val(response.data.uid);
                        this.$endUserNameInput.val(response.data.uid);
                        this.$endUserNameValue.val(response.data.name);
                        let endUserTpl = _.template(this.endUserDetailTpl.html());
                        this.$endUserSpanContent.html(endUserTpl(response.data));
                        this.$endUserSpanContent.removeClass('hidden');
                        if ($('#addressBookChanges').val() === 'true') {
                            this.addAddressToDropdown(response.data);
                            this.endUserAddressBookOptionSelected = $('#endUserUid').val();
                        }

                        if ($('.qut-endUser-selected').length) {
                            let endUserSel = _.template(this.endUserSelected.html());
                            this.$endUserSpanSelected.html(endUserSel(response.data));
                            this.eventAgg.trigger('addContactOnEndUserChange', response.data.contacts ? response.data.contacts : response.data.contact);
                            if ($('.qut-endUser-selected').length > 1) {
                                $('.qut-endUser-selected').first().remove();
                            }
                        }

                        this.$endUserSpanSelected.removeClass('hidden');
                        $('.field-level-address-error').addClass('hide');
                        this.eventAgg.trigger('selectEndUser', response.data.name); //informs SBA tab that end user has been selected
                        let hideSKUwarningMessage = seletedOption === 'NO_CHANGE' ? true : false;
                        if (isOrderEntrySite) {
                            this.eventAgg.trigger('refreshQuoteProductCart', true, true, hideSKUwarningMessage);
                        } else {
                            this.eventAgg.trigger('callShowCall');
                            if ($('#mitelSubscriptionOrder').val() === true || $('#mitelSubscriptionOrder').val() === 'true') {
                                $('.qut-configurations-tab-link').parent('.tab-title').addClass('hidden');
                                $('.qut-header-configurator').removeClass('hidden');
                                if (!$('#currency').hasClass('conditionally-disabled')) {
                                    $('#currency').attr('disabled', false);
                                }
                            }

                            if ($('#hasConfigureskusIdQuote').val() === 'true' || $('#mitelSubscriptionOrder').val() === true || $('#mitelSubscriptionOrder').val() === 'true') {
                                this.eventAgg.trigger('fetchVRFTableData');
                                if ($('.qut-vrf-tab-link').hasClass('active')) {
                                    setTimeout(() => {
                                        $('.qut-vrf-tab-link a').click();
                                    }, 2000);
                                }
                            }
                        }

                        this.eventAgg.trigger('updateSBATab'); //update SBA tab
                    }
                }.bind(this)).fail(function(error) {
                    this.$endUserAccountSearchBtn.removeClass('spinner-after');
                    this.$endUserAccountSearchBtn.removeClass('disabled');
                    this.$endUserAccountSearchBtn.attr('disabled', false);
                    this.$endUserGenericError.show();
                }.bind(this));
            }
        }
    });
})(westcon);
